package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.available_in_full_version
import com.eladfinish.bible.contest.constants.StringConstants.MAKAF
import com.eladfinish.bible.contest.data.common.stringResolver.IStringResolver
import com.eladfinish.bible.contest.screens.search.engine.ChapterSearchMatch
import com.eladfinish.bible.contest.screens.search.extensions.withGershaim
import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import com.eladfinish.bible.contest.utils.gematriaWord
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

class SearchChapterMatchesToSearchResultUiModelsUseCase(
    private val buildSearchResultSourceUseCase: BuildSearchResultSourceUseCase,
    private val stringResolver: IStringResolver,
) {

    operator fun invoke(
        matches: List<ChapterSearchMatch>,
        isPremium: Boolean,
        startIndex: Int,
    ): ImmutableList<VerseUiModel> =
        matches.mapIndexed { index, match ->
            val content = if (isPremium) {
                match.verseContent
            } else {
                match.verseContent.maskForNonPremium()
            }

            VerseUiModel(
                id = buildId(
                    match = match,
                    index = startIndex + index,
                ),
                text = content,
                source = buildSearchResultSourceUseCase(
                    bookName = match.bookName,
                    bookIndex = match.bookIndex,
                    chapter = match.chapterName,
                    verse = match.verseNumber,
                ),
                highlightedRanges = if (isPremium) {
                    match.groupRanges.toImmutableList()
                } else {
                    // אחרי masking אי אפשר לסמוך על ranges ישנים.
                    emptyList<IntRange>().toImmutableList()
                },
                bookIndex = match.bookIndex,
                chapterIndex = match.chapterName.gematriaWord(),
                verse = match.verseNumber,
            ).withGershaim()
        }.toImmutableList()

    private fun buildId(
        match: ChapterSearchMatch,
        index: Int,
    ): String =
        listOf(
            match.bookName,
            match.chapterName,
            match.verseNumber,
            index.toString(),
        ).joinToString(separator = "_")

    private fun String.maskForNonPremium(): String {
        val firstSpaceIndex = indexOf(" ")

        if (firstSpaceIndex <= 0) {
            return "${stringResolver.resolveString(SharedRes.strings.available_in_full_version.desc())}!"
        }

        var firstWord = take(firstSpaceIndex)

        if (firstWord.contains(MAKAF.toString())) {
            firstWord = firstWord.take(firstWord.indexOf(MAKAF) + 1)
        }

        return "$firstWord... (${stringResolver.resolveString(SharedRes.strings.available_in_full_version.desc())}!)"
    }
}
